import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { Location } from './models/Location.model';
import { Tenant } from './models/Tenant.model';

interface MultiTenantState {
    tenants: Tenant[];
    locations: Location[];
}

const initialState: MultiTenantState = {
    tenants: [],
    locations: [],
};

export const MultiTenantStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store) => ({
        setTenants(tenants: Tenant[]): void {
            patchState(store, () => ({ tenants: tenants }));
        },
        setLocations(locations: Location[]): void {
            patchState(store, () => ({ locations: locations }));
        },
    })),
);
